import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { menuInfo } from "@shared/type/CommonType";
import { global } from "@shared/libs/Global";
import {
  applySlip,
  fnGetIotype,
  getInitFormData,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { dateToString } from "@shared/utils/DateUtils";
import { showResizablePopupModal } from "@widgets/CommonModal";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import { RowNode } from "ag-grid-enterprise";
import SearchPanel from "@widgets/SearchPanel";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnButton } from "@shared/components/SnButton";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import SN_SCT_SIO_REG_003_POP_001 from "@menu/SCT/SN_SCT_SIO_REG_003/SN_SCT_SIO_REG_003_POP_001";

interface Props {
  Menuprops: menuInfo;
}

// 외주출고등록
const SN_SCT_SIO_REG_003 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();

  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });

  const iotypeRef = useRef<any[]>([]);
  const [selectedDocu, setSelectedDocu] = useState<string>("");

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData((prev: any) => ({
          ...(rtn.formData || {}),
          ...(prev || {}),
        }));
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      iotypeRef.current = await fnGetIotype("MTL", "2", "5", "");
    };
    fetchData();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const onSearch = async () => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved: any = await onSave();
        if (!isSaved) return;
      }
    }

    try {
      const params = {
        id: "sn_sct_sio_reg_003_01",
        params: searchRef.current.getFormdata(),
      };

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
        grid2: data[1] || [],
      });
    } catch (error: any) {}
  };

  const onInsert = () => {
    try {
      gridRefs.current["grid1"].current?.addRow();
    } catch (error: any) {}
  };

  const onBeforeAddRow1 = (): any => {
    try {
      const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
      if (modifiedRowsH.modifiedRowcount > 0) {
        showDialog("alter", "수정된 내용이 있습니다.");
        return false;
      }

      const searchInfo = searchRef.current.getFormdata();
      const today = dateToString(new Date());
      return {
        cd_firm: userInfo?.cd_firm,
        cd_biz: userInfo?.cd_biz,
        cd_cust: searchInfo.cd_cust,
        nm_cust_sort: searchInfo.nm_cust_sort,
        dt_req: today,
        cd_emp: userInfo?.cd_emp,
        nm_emp: userInfo?.nm_emp,
        cd_gp: userInfo?.cd_gp,
        cd_dept: userInfo?.cd_dept,
        cd_io: "510",
        fg_isu: "1",
        fg_trns: "1",
        rt_exch: 1,
        cd_exch: "000",
        tp_slip: "5",
        fg_slip: "2",
        fg_map: "3", // 외주
        am: 0,
        am_k: 0,
        am_vat: 0,
        am_supply: 0,
        no_hst: 0,
      };
    } catch (error: any) {
      return false;
    }
  };

  const onAddRow = () => {
    try {
      return gridRefs.current["grid2"].current?.addRow();
    } catch (error: any) {}
  };

  const onBeforeAddRow2 = (): any => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const focusedRowNodeH =
        gridRefs.current["grid1"].current.focusedRowNode();
      const today = dateToString(new Date());
      const maxNoLine =
        gridRefs.current["grid2"].current.getMaxValue("no_line");
      return {
        cd_firm: focusedNodeH.data?.cd_firm,
        cd_biz: focusedNodeH.data?.cd_biz,
        no_req: focusedNodeH.data?.no_req,
        no_line: maxNoLine + 1,
        dt_dlv: today,
        qt: 0,
        qt_isu: 0,
        qt_good: 0,
        qt_bad: 0,
        fg_matl: "1",
        cd_io: focusedRowNodeH.data?.cd_io,
        fg_isu: focusedRowNodeH.data?.fg_isu,
        fg_trns: focusedRowNodeH.data?.fg_trns,
        fg_slip: focusedRowNodeH.data?.fg_slip,
        tp_slip: focusedRowNodeH.data?.tp_slip,
        fg_money: focusedRowNodeH.data?.fg_money,
        rt_exch: focusedRowNodeH.data?.rt_exch,
        fg_map: focusedRowNodeH.data?.fg_map,
        fg_vat: "21",
        am: 0,
        am_k: 0,
        am_vat: 0,
        am_supply: 0,
        um: 0,
        um_k: 0,
        um_supply: 0,
        yn_req: "Y",
        dc_rmk: "",
      };
    } catch (error: any) {
      return false;
    }
  };

  const onDelete = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) return;

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");
    if (!confirm) return;

    gridRefs.current["grid2"].current.deleteAllRows();
    gridRefs.current["grid1"].current.deleteSelectedRows();

    const realDeletedRows =
      gridRefs.current["grid1"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      return;
    }

    return await onSave();
  };

  const onDeleteRow = async () => {
    const rowCount = gridRefs.current["grid2"].current?.getDisplayedRowCount();
    if (rowCount === 0) return;

    gridRefs.current["grid2"].current?.deleteSelectedRows();
    if (rowCount === 1) {
      const focusedRowNodeH =
        gridRefs.current["grid1"].current.focusedRowNode();
      gridRefs.current["grid1"].current.clearBlock(focusedRowNodeH);
    }
  };

  const onSave = async () => {
    const mtlQtoIH: any[] = [];
    const mtlQtoIL: any[] = [];
    const mtlQtoUH: any[] = [];
    const mtlQtoUL: any[] = [];
    const mtlQtoDH: any[] = [];
    const mtlQtoDL: any[] = [];

    try {
      gridRefs.current["grid1"].current.stopEditing();
      gridRefs.current["grid2"].current.stopEditing();

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const requiredValuesCheckL =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheckL) return false;

      const isuReqHChanges = gridRefs.current["grid1"].current.getChange();
      const isuReqLChanges = gridRefs.current["grid2"].current.getChange();

      const headerInserts = isuReqHChanges.insert ?? [];
      const lineInserts = isuReqLChanges.insert ?? [];
      if (headerInserts.length > 0 && lineInserts.length === 0) {
        await showDialog(
          "alter",
          "상세 정보가 없습니다.\n행추가하여 상세정보 작성 후 저장해 주시기 바랍니다."
        );
        return false;
      }

      for (const h of headerInserts) {
        if (!h.cd_cust) {
          await showDialog("alter", "외주처은(는) 필수값입니다.");
          return;
        }
        if (!h.cd_wh) {
          await showDialog("alter", "출고창고은(는) 필수값입니다.");
          return;
        }
      }

      if (
        isuReqHChanges.modifiedRowcount === 0 &&
        isuReqLChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      for (let row of headerInserts) {
        if (!row.no_req) {
          const noSlip = await applySlip({
            cd_column: "no_req",
            cd_module: "MTL",
            no_line: 18,
            cd_prefix: "",
            dt: row.dt_req,
            girdrefs: [gridRefs.current["grid1"], gridRefs.current["grid2"]],
            inserts: [isuReqHChanges, isuReqLChanges],
            cd_menu: Menuprops.cd_menu,
          });
          gridRefs.current["grid2"].current.applyFilters({ no_req: noSlip });

          if (noSlip) {
            row.no_req = noSlip;
            const qtioH = {
              cd_firm: userInfo.cd_firm,
              no_io: noSlip,
              cd_biz: row?.cd_biz,
              dt_io: row.dt_req,
              cd_cust: row?.cd_cust,
              cd_cust_dlv: row?.cd_cust ?? null,
              cd_exch: row?.cd_exch,
              rt_exch: row?.rt_exch ?? 0,
              fg_trns: row?.fg_trns,
              cd_io: row?.cd_io,
              yn_autoprocess: "Y",
              fg_map: row?.fg_map ?? "3",
              am: row?.am,
              am_k: row?.am_k,
              am_vat: row?.am_vat,
              am_supply: row?.am_supply,
              cd_wh_ref: row?.cd_cust,
              cd_emp: row?.cd_emp ?? userInfo.cd_emp,
              cd_dept: userInfo.cd_dept,
              cd_gp: row?.cd_gp,
              cd_mgmtdtl: row?.cd_mgmtdtl ?? null,
              fg_slip: row?.fg_slip ?? "2",
              tp_slip: row?.tp_slip ?? "5",
              fg_io: row?.fg_isu ?? "1",
              fg_money: row?.fg_money ?? "2",
              dc_rmk: row?.dc_rmk,
              no_hst: 0,
            };
            mtlQtoIH.push(qtioH);
            for (let rowL of lineInserts) {
              if (!rowL.no_req) {
                if (noSlip) {
                  rowL.no_req = noSlip;
                }
              }
              const qtioL = {
                cd_firm: userInfo.cd_firm,
                no_io: noSlip,
                cd_item: rowL?.cd_matl,
                cd_wh: row?.cd_wh,
                cd_biz: row?.cd_biz,
                cd_io: row?.cd_io ?? "510",
                fg_io: row?.fg_isu ?? "1",
                fg_slip: row?.fg_slip ?? "2",
                tp_slip: row?.tp_slip ?? "5",
                fg_money: row?.fg_money ?? "2",
                dt_io: row.dt_req,
                qt: rowL?.qt ?? 0,
                qt_good: rowL?.qt_good ?? 0,
                qt_bad: rowL?.qt_bad ?? 0,
                um: rowL?.um ?? 0,
                um_k: rowL?.um_k ?? 0,
                am: rowL?.am ?? 0,
                am_k: rowL?.am_k ?? 0,
                am_vat: rowL?.am_vat ?? 0,
                um_supply: rowL?.um_supply ?? 0,
                am_supply: rowL?.am_supply ?? 0,
                fg_vat: rowL?.fg_vat,
                no_order: rowL?.no_po,
                no_line_order: rowL?.no_line_pol,
                cd_pjt: rowL?.cd_pjt,
                dc_rmk: rowL?.dc_rmk,
                no_req: rowL?.no_req,
                no_line_req: rowL?.no_line,
                no_line: rowL?.no_line,
                qt_cls: rowL?.qt_cls ?? 0,
                rt_exch: rowL?.rt_exch ?? 0,
                yn_req: "Y",
                fg_map: row.fg_map ?? "3",
              };
              mtlQtoIL.push(qtioL);
            }
          }
        }
      }

      const headerDeletes = isuReqHChanges.delete ?? [];
      const lineDeletes = isuReqLChanges.delete ?? [];

      for (let rowDL of lineDeletes) {
        const qtioL = {
          cd_firm: rowDL?.cd_firm,
          no_io: rowDL?.no_req,
          no_line: rowDL?.no_line,
          fg_slip: rowDL?.fg_slip ?? "2",
        };
        mtlQtoDL.push(qtioL);
      }

      for (let rowDH of headerDeletes) {
        const qtioH = {
          cd_firm: userInfo.cd_firm,
          no_io: rowDH?.no_req,
        };
        mtlQtoDH.push(qtioH);
      }

      const saveData = {
        isuReqH: isuReqHChanges,
        isuReqL: isuReqLChanges,
      };
      const saveData2: any = {
        qtioh: {},
        qtio: {},
      };

      if (mtlQtoIH || mtlQtoIL) {
        saveData2.qtioh.insert = mtlQtoIH || [];
        saveData2.qtio.insert = mtlQtoIL || [];
      }

      if (mtlQtoUH || mtlQtoUL) {
        saveData2.qtioh.update = mtlQtoUH || [];
        saveData2.qtio.update = mtlQtoUL || [];
      }

      if (mtlQtoDH || mtlQtoDL) {
        saveData2.qtioh.delete = mtlQtoDH || [];
        saveData2.qtio.delete = mtlQtoDL || [];
      }

      const saveDataAll = {
        ...saveData,
        ...saveData2,
      };

      const ok = await fnSave("SN_SCT_SIO_REG_003_SAVE_01", saveDataAll);
      if (!ok) return false;

      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid1"].current.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid2"].current.resetUpdate(true);
      gridRefs.current["grid1"].current.resetUpdate(true);
      return false;
    }
  };

  const onGrid1BtnsClick = async (id: string) => {
    if (id == "btnApply") {
      const isuReqHChanges =
        gridRefs.current["grid1"].current.getChange().insert;
      if (isuReqHChanges.length === 0) {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }

      const searchInfo = searchRef.current.getFormdata();
      const selectedData = {
        cd_biz: searchInfo.cd_biz,
        cd_cust: searchInfo.cd_cust,
        dt_from: searchInfo.dt_from,
        dt_to: searchInfo.dt_to,
      };

      const component = (
        <SN_SCT_SIO_REG_003_POP_001 selectedData={selectedData} />
      );
      const result = await showResizablePopupModal({
        title: "발주적용 도움",
        children: component,
        validation: true,
      });
      if (!result || result === "close") return;

      const headerResult = result[0];
      const lineResult = result[1];

      const focusedRowNodeH =
        gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedRowNodeH && headerResult[0]) {
        for (const key in headerResult[0]) {
          if (key != "no_req")
            focusedRowNodeH.setDataValue(key, headerResult[0][key], "noEvent");
        }
        gridRefs.current["grid1"].current.applyBlock(focusedRowNodeH);
      }
      lineResult.map((result: any) => {
        if (headerResult[0]) {
          const addedNode = onAddRow();
          if (addedNode) {
            for (const key in result) {
              if (key != "no_line")
                addedNode.setDataValue(key, result[key], "noEvent");
            }
            addedNode.setDataValue("qt_good", result.qt_app);
          }
        }
      });
    }
  };

  const onGrid2BtnsClick = async (id: string) => {
    if (id == "deleteRow") {
      onDeleteRow();
    }
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const no_req = selectedRow.no_req;
      setSelectedDocu(no_req);
    }
  };

  const onCellValueChanged1 = async (event: CellValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;

    if (colId === "cd_io") {
      let targetIo: any;
      for (const io of iotypeRef.current) {
        if (io.cd_io === rowData.cd_io) targetIo = io;
      }
      if (targetIo) {
        // rowNode.setDataValue("fg_slip", targetIo.fg_slip);
        // rowNode.setDataValue("tp_slip", targetIo.tp_slip);
        // rowNode.setDataValue("fg_io", targetIo.fg_io);
        // rowNode.setDataValue("fg_map", targetIo.fg_map);
        rowNode.setDataValue("fg_isu", targetIo.fg_slip);

        gridRefs.current["grid2"].current.forEachFilteredNode(
          (node: RowNode) => {
            // node.setDataValue("cd_io", rowData.cd_io, "noEvent");
            // node.setDataValue("fg_slip", targetIo.fg_slip, "noEvent");
            // node.setDataValue("tp_slip", targetIo.tp_slip, "noEvent");
            // node.setDataValue("fg_io", targetIo.fg_io, "noEvent");
            // node.setDataValue("fg_map", targetIo.fg_map, "noEvent");
            node.setDataValue("fg_isu", targetIo.fg_isu, "noEvent");
          }
        );
      }
    }
    if (colId === "cd_wh") {
      gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
        node.setDataValue("cd_wh", rowData.cd_wh, "noEvent");
      });
    }
  };

  const onCellValueChanged2 = async (event: any) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;

    switch (colId) {
      case "qt_good":
      case "qt_bad":
        rowNode.setDataValue("qt", rowData.qt_good + rowData.qt_bad, "noEvent");
        break;
    }
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
          onCellValueChanged: onCellValueChanged1,
          onBeforeAddRow: onBeforeAddRow1,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onBeforeAddRow: onBeforeAddRow2,
          onBtnDeleteClick: onGrid2BtnsClick,
          onCellValueChanged: onCellValueChanged2,
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="flex-1 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{ rowSelection: "single", title: "의뢰정보" }}
            events={grids.grid1.events}
            header={
              <div>
                <SnButton
                  text={"발주적용"}
                  onClick={() => {
                    onGrid1BtnsClick("btnApply");
                  }}
                />
              </div>
            }
            filter={{ refs: [gridRefs.current["grid2"]], columns: ["no_req"] }}
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid2"]}
            columnConfig={grids.grid2.columns}
            rowData={grids.grid2.dataSource}
            etcProps={{ rowSelection: "single", title: "상세정보" }}
            events={grids.grid2.events}
          />
        </SnResizeBar>
        <SnFileUploadBox selectedDocu={selectedDocu} selectedLineDocu={0} />
      </div>
    </div>
  );
});

export default SN_SCT_SIO_REG_003;
